import React, { useEffect, useState } from "react";
import axios from "axios";
import { URLs } from "constants/urls";
import { userService } from '../../../services/user.service';
import { toastNotification } from "common/util_function";
import FundForm from "components/Fundraising/Form";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { formattedDateTime } from "common/util_function";

const defaultData = {
  id: "",
  projectId: "",
  categoryId: "",
  totalRaise: "",
  leadInvestorIds: [],
  investorIds: [],
  raiseDate: new Date(),
  announcementLink: ""
};

const defaultConfig = {
  projectList: []
}

const FundraisingForm = (props) => {
  const [config, setConfig] = useState(defaultConfig);
  const history = useHistory();
  const formData = { ...defaultData, ...props?.location?.data };

  useEffect(() => {
    const loadData = async () => {
      const projects = await getProjectList();
      const investors = await getInvestors();
      const projectList = projects.filter(item => +item.isLaunchpad === 0);
      const fundingRounds = await getCategoryList(7);
      setConfig({ ...config, projectList, fundingRounds, investors });
    }
    loadData();
    return () => {
      setConfig(defaultConfig)
    }
  }, [])

  const getInvestors = async () => {
    const url = URLs.investors.all;
    return await axios.get(url).then((response) => response.data.data);
  };

  const getProjectList = async () => {
    const url = URLs.project.all;
    return await axios.get(url).then((response) => response.data.data);
  };

  const getCategoryList = async (typeId) => {
    const url = `${URLs.category.list}?typeId=${typeId}`;
    return await axios.get(url).then((response) => response.data.data);
  };

  const onSubmit = async (fields) => {
    let investorList = [];
    let leadInvestorList = [];
    if (fields.investorIds && fields.investorIds.length > 0) {
      investorList = fields.investorIds.map((item) => {
        return {id: item.id, isLead: false};
      });
    }
    if (fields.leadInvestorIds && fields.leadInvestorIds.length > 0) {
      leadInvestorList = fields.leadInvestorIds.map((item) => {
        return {id: item.id, isLead: true};
      });
    }
    const investors = [...leadInvestorList, ...investorList];
    delete fields.leadInvestorIds;
    delete fields.investorIds;

    const config = {
      method: "post",
      url: URLs.fundraising.form,
      data: { ...fields, userId: userService.userId(), investors },
    };

    axios(config)
      .then((response) => {
        if (response.data.code === 200) {
          toastNotification("success", response.data.message);
          history.push("/admin/fundraising");
        } else {
          toastNotification("error", response.data.message);
          throw new Error(response.data.message);
        }
      })
      .catch((error) => {
        toastNotification("error", error);
      });
  }

  return (
    <div className="flex flex-wrap">
      <div className="w-full lg:w-12/12 mt-20 px-4">
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-gray-800 text-xl font-bold uppercase">Fundraising Form</h6>
              <Link
                className="bg-blue-800 text-white focus:outline-none font-bold py-2 px-4 rounded"
                to="/admin/fundraising"
              >
                Back
              </Link>
            </div>
            <span className="text-xs italic">Please fill all the mandatory(<span className="text-red-500">*</span>) files </span>
          </div>
          <div className="w-full">
            <FundForm onSubmit={onSubmit} config={config} formData={formData} />
          </div>
        </div>
      </div>
    </div>
  );
}
export default FundraisingForm;